// @ts-nocheck
import React from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';

// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});
// redux seters
import { setAuth } from '../../../redux/reducers/admin';

function PublicLayout() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    Cookies.set('weighbridgeAdmin', 'adminResult.data.jwtToken', {
      expires: 7,
    });
    dispatch(
      setAuth({
        token: 'adminResult.data.jwtToken',
        adminInfo: 'adminResult.data',
        isAuthenticated: true,
      }),
    );
  }, []);
  return (
    <div
      dir="rtl"
      className="row  justify-content-center"
      style={{ backgroundColor: '#2e3349' }}
    >
      <CacheProvider value={cacheRtl}>
          <Outlet />
      </CacheProvider>
    </div>
  );
}

export default PublicLayout;
